/**
 * @generated SignedSource<<af66f2d8e90d7fbac29529215a8d71cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewLayoutSummaryField_IssueViewSummaryField$data = {
  readonly key: string;
  readonly summaryField: {
    readonly __typename: "JiraSingleLineTextField";
    readonly fieldId: string;
    readonly type: string;
    readonly " $fragmentSpreads": FragmentRefs<"singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView">;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueViewLayoutSummaryField_IssueViewSummaryField";
};
export type ui_issueViewLayoutSummaryField_IssueViewSummaryField$key = {
  readonly " $data"?: ui_issueViewLayoutSummaryField_IssueViewSummaryField$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutSummaryField_IssueViewSummaryField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueViewLayoutSummaryField_IssueViewSummaryField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "JiraSingleLineTextField",
      "kind": "LinkedField",
      "name": "summaryField",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
        },
        {
          "kind": "ScalarField",
          "name": "fieldId"
        },
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "3659d93e642bbfa0845a3ec047516057";

export default node;
